import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { getBannerByPageItemType } from '../types/bannerSchema';

export const getBannerByPage = createAsyncThunk<getBannerByPageItemType[], { regionId: number; code: string; shopId?: number }>(
  'banner/getBannerByPage',
  async query => {
    return await MyAxios.post<getBannerByPageItemType>('/api/banner/get', query)
      .then(handleResponse)
      .catch(error => handleError(error, []));
  },
);
